import ShopLayout from "../../components/signup/shop-layout";
import Payment from "../payment";
import { useLocation } from "react-router-dom";

export default function ShopPayment() {
  const location = useLocation();

  const { cellPhone, type, isShopPendingCustomer, requestUniqueId } =
    location.state || {};

  console.log("isShopPendingCustomer", isShopPendingCustomer);
  console.log("requestUniqueId", requestUniqueId);

  return (
    <ShopLayout
      step={type === 40 ? 5 : 4}
      type={type}
      steps={type === 40 ? [4, 5, 6] : [3, 4, 5]}
    >
      <Payment
        isShop={true}
        cellPhone={cellPhone}
        type={type}
        isShopPendingCustomer={isShopPendingCustomer}
        requestUniqueId={requestUniqueId}
      />
    </ShopLayout>
  );
}
